import React, { Component } from "react";
import Fade from "react-reveal";

class Portfolio extends Component {
  render() {
    if (!this.props.data) return null;

    return (
      <section id="portfolio">
        <Fade left duration={1000} distance="40px">
          <div className="row">
            <div className="twelve columns collapsed">
              <h1>Result:</h1>
              <iframe width="840" height="473" src="https://www.youtube.com/embed/ax8y1MMtJmo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              <h1>Conclusion:</h1>
              <p>
                Due to a lack of time this project couldn't be fully completed.
                Originally I had a teammate, Ahmet Ustun (1210295), that abandoned the course at the start of this final project.
                Being alone was one of my main drawbacks, as I dont have enough work-force to develop all the planned features.
                Also I didnt have any experience with microprocessor programming, nor real electronics.
                Nevertheless, this project has complemented and finished my expected formation about electronics. It also has show me how extense and complicated the world of microelectronics can really be.
                I also want to thank my teacher and mentor of this project, Jorge Mamede, that helped me reach my goals and identify the right path of work.
              </p>
              <h1>Next steps:</h1>
              <p>
                This project can be improved in many ways. I'm sure there is a more easy rewrite of the chess library, and a better build of hardware (for example implementing the demux talked above). Here are some planned features that didnt see the light:
                <ul>
                  <li>• Converting the games to Portable Game Notation, saving them to a file.</li>
                  <li>• Time control via timers of ATMEGA + display.</li>
                  <li>• Light sensor that lights up the board when there is not enough light to see.</li>
                  <li>• Use of batteries for improving the portability (a computer wont be needed).</li>
                  <li>• Analysis of games played to recognize patterns (help improve at the game).</li>
                </ul>
                I'm looking foward to taking this project as an iteration and rebuilding it, now with all the knowlegde acquired, making a better version.
              </p>
            </div>
          </div>
        </Fade>
      </section>
    );
  }
}

export default Portfolio;
